<template>
  <div>
    <heads />
    <app-main />
    <Backtop/>
    <Loading :loading="loading"/>
  </div>
</template>

<script>
import heads from './heads'
import content from './content'
import Backtop from './Backtop'
import Loading from './Loading'
export default {
  name: 'LayOut',
  components: {
    heads,
    appMain: content,
    Backtop,
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.loading = true
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 2000)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/LayOut/index.vue